<template>
  <div class="components-attr-edit">
    <el-scrollbar class="components-attr-edit">
      <p v-if="!activeElementUUID" class="page-title fontBold">页面动作</p>
      <div
        class="attr-edit-inner"
        v-if="activeElementUUID || activeElementGroupUUID || !activeElementUUID"
      >
        <div class="animate-edit-btn-wrapper">
          <el-dropdown>
            <el-button type="primary" size="small">
              添加动作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in !activeElementUUID
                  ? pageEventTypeList
                  : eventTypeList"
                :key="index"
              >
                <div @click="addEvent(item.value)">{{ item.label }}</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <p
            class="gray inline-block fontsize-12 marginL10"
            style="color: #fff"
          >
            动作在编辑模式下无效果
          </p>
        </div>
        <div
          class="el-animate-list-wrapper paddingT20"
          v-show="
            (activeElementGroupUUID && activeElementGroup.events.length) ||
            (!activeElementGroupUUID &&
              activeElement &&
              activeElement.events.length) ||
            !activeElementUUID
          "
        >
          <el-collapse accordion>
            <el-collapse-item
              v-for="(item, index) in activeElementGroupUUID
                ? activeElementGroup.events
                : activeElementUUID
                ? activeElement.events
                : activePage.events"
              :key="index"
            >
              <template slot="title">
                <span class="el-animate-title-name">动作 {{ index + 1 }}</span>
                <div class="el-animate-title-type-wrapper">
                  <span v-if="!activeElementUUID">{{
                    item.type | getLabelText(pageEventTypeList)
                  }}</span>
                  <span v-else>{{
                    item.type | getLabelText(eventTypeList)
                  }}</span>
                  <span
                    >-{{ item.action | getLabelText(clickTypeList)
                    }}{{
                      item.action == "wait" && item.millisecond
                        ? `-${item.millisecond}毫秒`
                        : ""
                    }}</span
                  >
                </div>
                <span
                  class="el-animate-title-btn"
                  @click.stop.prevent="deleteEvent(index)"
                  ><i class="el-icon-delete"></i
                ></span>
              </template>

              <div class="el-animate-item">
                <div
                  class="attr-item-edit-wrapper"
                  v-show="['click', 'load'].includes(item.type)"
                >
                  <div class="col-1 attr-item-edit-input">
                    <el-dropdown>
                      <el-button type="primary" size="small">
                        选择事件<i
                          class="el-icon-arrow-down el-icon--right"
                        ></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          v-for="(i, k) in clickTypeList"
                          :key="k"
                        >
                          <div @click="addAction(i.value, index)">
                            {{ i.label }}
                          </div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
                <div
                  class="attr-item-edit-wrapper"
                  v-show="item.action == 'link'"
                >
                  <p class="attr-item-title">链接/接口url：</p>
                  <div class="col-1 attr-item-edit-input">
                    <el-input
                      type="textarea"
                      :rows="3"
                      placeholder="请输入url"
                      v-model="item.url"
                    />
                  </div>
                </div>
                <div
                  class="attr-item-edit-wrapper"
                  v-show="item.action == 'router'"
                >
                  <p class="attr-item-title">选择页面：</p>
                  <div class="col-1 attr-item-edit-input">
                    <el-select v-model="item.pageUUID" placeholder="选择页面">
                      <el-option
                        v-for="m in getPages"
                        :key="m.value"
                        :label="m.label"
                        :value="m.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div
                  class="attr-item-edit-wrapper"
                  v-show="item.action == 'dynamicPanel'"
                >
                  <p class="attr-item-title">动态面板：</p>
                  <div class="col-1 attr-item-edit-input">
                    <el-select
                      v-model="item.dynamicPanelUUID"
                      placeholder="选择动态面板"
                    >
                      <el-option
                        v-for="m in getDynamicPanel"
                        :key="m.uuid"
                        :label="m.elNameShow"
                        :value="m.uuid"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div
                  class="attr-item-edit-wrapper"
                  v-show="
                    item.action == 'dynamicPanel' && item.dynamicPanelUUID
                  "
                >
                  <p class="attr-item-title">State：</p>
                  <div class="col-1 attr-item-edit-input">
                    <el-select
                      v-model="item.dynamicPanelStateUUID"
                      placeholder="选择State"
                    >
                      <el-option
                        v-for="m in getDynamicPanelState(item.dynamicPanelUUID)"
                        :key="m.uuid"
                        :label="m.name"
                        :value="m.uuid"
                      >
                      </el-option>
                      <el-option label="下一项" value="next"></el-option>
                      <el-option label="上一项" value="prev"></el-option>
                    </el-select>
                  </div>
                </div>
                <div
                  class="attr-item-edit-wrapper"
                  v-show="
                    item.action == 'dynamicPanel' && item.dynamicPanelStateUUID
                  "
                >
                  <p class="attr-item-title">循环：</p>
                  <div class="col-1 attr-item-edit-input">
                    <el-select
                      v-model="item.dynamicPanelLoop"
                      placeholder="选择循环"
                    >
                      <el-option label="是" :value="1"></el-option>
                      <el-option label="否" :value="0"></el-option>
                    </el-select>
                  </div>
                </div>
                <div
                  class="attr-item-edit-wrapper"
                  v-show="
                    item.action == 'dynamicPanel' && item.dynamicPanelStateUUID
                  "
                >
                  <p class="attr-item-title">进入动画：</p>
                  <div class="col-1 attr-item-edit-input">
                    <el-select
                      style="width: 110px"
                      v-model="item.dynamicPanelAnimationIn"
                      placeholder="选择动画"
                    >
                      <el-option label="无" value=""></el-option>
                      <el-option
                        v-for="(i, k) in dynamicPanelAnimationInList"
                        :key="k"
                        :label="i.label"
                        :value="i.value"
                      ></el-option>
                    </el-select>
                    <el-input
                      style="width: 70px; margin: 0 5px 0 10px"
                      placeholder="毫秒"
                      v-model="item.dynamicPanelAnimationInMillisecond"
                    />
                    毫秒
                  </div>
                </div>
                <div
                  class="attr-item-edit-wrapper"
                  v-show="
                    item.action == 'dynamicPanel' && item.dynamicPanelStateUUID
                  "
                >
                  <p class="attr-item-title">退出动画：</p>
                  <div class="col-1 attr-item-edit-input">
                    <el-select
                      style="width: 110px"
                      v-model="item.dynamicPanelAnimationOut"
                      placeholder="选择动画"
                    >
                      <el-option label="无" value=""></el-option>
                      <el-option
                        v-for="(i, k) in dynamicPanelAnimationOutList"
                        :key="k"
                        :label="i.label"
                        :value="i.value"
                      ></el-option>
                    </el-select>
                    <el-input
                      style="width: 70px; margin: 0 5px 0 10px"
                      placeholder="毫秒"
                      v-model="item.dynamicPanelAnimationOutMillisecond"
                    />
                    毫秒
                  </div>
                </div>
                <div
                  class="attr-item-edit-wrapper"
                  v-show="item.action == 'wait'"
                >
                  <p class="attr-item-title">毫秒：</p>
                  <div class="col-1 attr-item-edit-input">
                    <el-input
                      placeholder="请输入毫秒"
                      v-model="item.millisecond"
                    />
                  </div>
                </div>
                <div
                  class="attr-item-edit-wrapper"
                  v-show="
                    ['show', 'hide', 'setSize', 'setZIndex'].includes(
                      item.action
                    )
                  "
                >
                  <p class="attr-item-title">选择元件：</p>
                  <div class="col-1 attr-item-edit-input">
                    <el-cascader
                      :value="getElementUUIDs(index)"
                      :options="elementManage"
                      :props="{
                        children: 'list',
                        label: 'name',
                        value: 'uuid',
                        multiple: ['setSize', 'setZIndex'].includes(item.action)
                          ? false
                          : true,
                      }"
                      clearable
                      @change="(e) => elementUUIDsChange(e, index, item.action)"
                    >
                      <template slot-scope="{ node, data }">
                        <span
                          :style="`height:100%;display:block;`"
                          @mouseenter="
                            (e) => elementUUIDsMouseEnterHandler(e, data)
                          "
                          @mouseleave="
                            (e) => elementUUIDsMouseLeaveHandler(e, data)
                          "
                          >{{ data.label }}</span
                        >
                      </template>
                    </el-cascader>
                  </div>
                </div>
                <div
                  class="attr-item-edit-wrapper"
                  v-show="['setSize'].includes(item.action)"
                >
                  <p class="attr-item-title">尺寸：</p>
                  <div class="col-1 attr-item-edit-input">
                    <el-input-number
                      size="mini"
                      v-model="item.setWidth"
                      controls-position="right"
                      :min="0"
                      @change="widthHandler(item, index)"
                    />
                    <div class="attr-item-edit-input-des">宽度</div>
                  </div>
                  <div
                    class="align-type-item clearFlex"
                    @click="item.widthHeightLocked = !item.widthHeightLocked"
                  >
                    <el-tooltip
                      effect="dark"
                      content="锁住原始比例"
                      placement="bottom"
                    >
                      <i
                        class="iconfont icontongbu"
                        :style="
                          item.widthHeightLocked
                            ? {
                                color: 'white',
                                background: '#25A589',
                                marginRight: '10px',
                              }
                            : { marginRight: '10px' }
                        "
                      ></i>
                    </el-tooltip>
                  </div>
                  <div class="col-1 attr-item-edit-input">
                    <el-input-number
                      size="mini"
                      v-model="item.setHeight"
                      controls-position="right"
                      :min="0"
                      @change="heightHandler(item, index)"
                    />
                    <div class="attr-item-edit-input-des">高度</div>
                  </div>
                </div>
                <div
                  class="attr-item-edit-wrapper"
                  v-show="item.action == 'setZIndex'"
                >
                  <p class="attr-item-title">置顶/底：</p>
                  <div class="col-1 attr-item-edit-input">
                    <el-select
                      v-model="item.setZIndex"
                      placeholder="选择置顶/底"
                    >
                      <el-option label="无" :value="0"></el-option>
                      <el-option label="置顶" :value="1"></el-option>
                      <el-option label="置底" :value="2"></el-option>
                    </el-select>
                  </div>
                </div>
                <div
                  class="attr-item-edit-wrapper"
                  v-show="item.action == 'setBackgroundMusic'"
                >
                  <p class="attr-item-title">开启/关闭：</p>
                  <div class="col-1 attr-item-edit-input">
                    <el-select
                      v-model="item.setBackgroundMusic"
                      placeholder="选择开启/关闭"
                    >
                      <el-option label="无" :value="0"></el-option>
                      <el-option label="开启" :value="1"></el-option>
                      <el-option label="关闭" :value="2"></el-option>
                    </el-select>
                  </div>
                </div>

                <div
                  class="attr-item-edit-wrapper"
                  v-show="item.action == 'wxMiniProgramNavigateTo'"
                >
                  <miniProgramForm v-model="item.parmas"></miniProgramForm>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div v-else>
        <p class="gray paddingT30 text-center">请在画板上选择需要编辑得元素</p>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { cloneDeep } from "lodash";
import miniProgramForm from "./eventEditForms/miniProgramForm.vue";

export default {
  name: "event-edit",
  components: { miniProgramForm },
  data() {
    return {
      dynamicPanelAnimationInList: [
        {
          label: "向左滑动",
          value: "slideInRight",
        },
        {
          label: "向右滑动",
          value: "slideInLeft",
        },
        {
          label: "向上滑动",
          value: "slideInDown",
        },
        {
          label: "向下滑动",
          value: "slideInUp",
        },
      ],
      dynamicPanelAnimationOutList: [
        {
          label: "向左滑动",
          value: "slideOutLeft",
        },
        {
          label: "向右滑动",
          value: "slideOutRight",
        },
        {
          label: "向上滑动",
          value: "slideOutUp",
        },
        {
          label: "向下滑动",
          value: "slideOutDown",
        },
      ],
      pageEventTypeList: [
        {
          label: "载入时",
          value: "load",
        },
      ],
      eventTypeList: [
        {
          label: "单击时",
          value: "click",
        },
      ],
      clickTypeList: [
        {
          label: "显示",
          value: "show",
        },
        {
          label: "隐藏",
          value: "hide",
        },
        {
          label: "等待",
          value: "wait",
        },
        {
          label: "跳转外链",
          value: "link",
        },
        {
          label: "跳转内页",
          value: "router",
        },
        {
          label: "设置面板状态",
          value: "dynamicPanel",
        },
        {
          label: "设置尺寸",
          value: "setSize",
        },
        {
          label: "置顶/置底",
          value: "setZIndex",
        },
        {
          label: "设置背景音乐",
          value: "setBackgroundMusic",
        },
        {
          label: "跳转小程序",
          value: "wxMiniProgramNavigateTo",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      projectData: (state) => state.editor.projectData,
      activePageUUID: (state) => state.editor.activePageUUID,
      activeElementUUID: (state) => state.editor.activeElementUUID,
      activeElementGroupUUID: (state) => state.editor.activeElementGroupUUID,
    }),
    ...mapGetters([
      "currentPageIndex",
      "activeElementIndex",
      "activeElement",
      "activePage",
      "activeElementGroup",
      "elementManage",
      "elementManageWithElType",
    ]),
    getPages() {
      return this.projectData.pages.map((i, k) => {
        return {
          value: i.uuid,
          label: i.name ? i.name : `第${k + 1}页`,
        };
      });
    },
    getDynamicPanel() {
      return this.activePage.elements.filter((i) => i.isDynamicPanel);
    },
  },
  mounted() {
    console.log(this.elementManage, "this.elementManage!!!!!");
  },
  methods: {
    widthHandler(item, index) {
      const elem = this.activePage.elements.find(
        (i) => i.uuid == item.elementUUIDs[item.elementUUIDs.length - 1].uuid
      );
      if (elem && item.widthHeightLocked) {
        const height = (
          item.setWidth *
          (elem.originValue.height / elem.originValue.width)
        ).toFixed(2);
        if (this.activeElementUUID) {
          this.activeElement.events[index].setHeight = height;
        } else if (this.activeElementGroupUUID) {
          this.activeElementGroup.events[index].setHeight = height;
        } else {
          this.activePage.events[index].setHeight = height;
        }
      }
    },
    heightHandler(item, index) {
      const elem = this.activePage.elements.find(
        (i) => i.uuid == item.elementUUIDs[item.elementUUIDs.length - 1].uuid
      );
      if (elem && item.widthHeightLocked) {
        const width = (
          item.setHeight *
          (elem.originValue.width / elem.originValue.height)
        ).toFixed(2);
        if (this.activeElementUUID) {
          this.activeElement.events[index].setWidth = width;
        } else if (this.activeElementGroupUUID) {
          this.activeElementGroup.events[index].width = width;
        } else {
          this.activePage.events[index].width = width;
        }
      }
    },
    getDynamicPanelState(dynamicPanelUUID) {
      return dynamicPanelUUID
        ? this.activePage.elements.find((i) => i.uuid == dynamicPanelUUID)
            .states
        : [];
    },
    /**
     * 添加事件
     * @param type 事件名称
     */
    addEvent(type) {
      if (this.activeElementUUID || this.activeElementGroupUUID) {
        this.$store.dispatch("addElementEvent", type);
      } else {
        this.$store.dispatch("addPageEvent", type);
      }
    },
    /**
     * 删除事件
     * @param index
     */
    deleteEvent(index) {
      if (this.activeElementUUID || this.activeElementGroupUUID) {
        this.$store.dispatch("deleteElementEvent", index);
      } else {
        this.$store.dispatch("deletePageEvent", index);
      }
    },
    /**
     * 选择单击时事件
     * @param type 交互名称
     * @param index
     */
    addAction(data, index) {
      if (this.activeElementUUID || this.activeElementGroupUUID) {
        this.$store.dispatch("addElementEventAction", { index, data });
      } else {
        this.$store.dispatch("addPageEventAction", { index, data });
      }
    },
    /**
     * 选择显示/隐藏的元件
     * @param type 交互名称
     * @param index
     */
    elementUUIDsChange(e, index, action) {
      console.log(e, index, action, "elementUUIDsChange-begin");
      const data = this.transformArray(e);
      data.map((i) => {
        const elementGroupCheck = this.activePage.elementGroups.find(
          (z) => z.uuid == i.uuid
        );
        i.isGroup = elementGroupCheck ? 1 : 0;
        const elementCheck = this.activePage.elements.find(
          (z) => z.uuid == i.uuid
        );
        i.isDynamicPanel = elementCheck && elementCheck.isDynamicPanel ? 1 : 0;
      });
      console.log(data, "elementUUIDsChange-data");
      if (this.activeElementUUID || this.activeElementGroupUUID) {
        this.$store.dispatch("addElementEventActionElementUUIDs", {
          index,
          data: data,
        });
      } else {
        this.$store.dispatch("addPageEventActionElementUUIDs", {
          index,
          data: data,
        });
      }
      if ("setSize" == action) {
        const elem = this.activePage.elements.find(
          (i) => i.uuid == data[data.length - 1].uuid
        );
        if (elem) {
          if (this.activeElementUUID) {
            this.activeElement.events[index].setWidth = elem.commonStyle.width;
            this.activeElement.events[index].setHeight =
              elem.commonStyle.height;
          } else if (this.activeElementGroupUUID) {
            this.activeElementGroup.events[index].setWidth =
              elem.commonStyle.width;
            this.activeElementGroup.events[index].setHeight =
              elem.commonStyle.height;
          } else {
            this.activePage.events[index].setWidth = elem.commonStyle.width;
            this.activePage.events[index].setHeight = elem.commonStyle.height;
          }
        }
      }
    },
    transformArray(arr) {
      const result = {};
      const arrClone = cloneDeep(arr);
      function createNestedObjectHelper(current, id) {
        let next = current.find((obj) => obj.uuid === id);
        if (!next) {
          next = { uuid: id };
          current.push(next);
        }
        return next;
      }
      function createNestedObject(current, ids) {
        if (ids.length === 0) {
          return;
        }
        if (ids.length === 1) {
          createNestedObjectHelper(current, ids[0]);
          return;
        }
        const id = ids.shift();
        const next = createNestedObjectHelper(current, id);
        createNestedObject(next.list || (next.list = []), ids);
      }
      for (let i = 0; i < arrClone.length; i++) {
        const currentArr = Array.isArray(arrClone[i])
          ? arrClone[i]
          : [arrClone[i]];
        const ids = currentArr;
        createNestedObject(result.list || (result.list = []), ids);
      }
      return result.list ? result.list : {};
    },
    convertTo2DArray(arr, size) {
      const result = [];
      for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
      }
      return result;
    },
    getElementUUIDs(index) {
      const getArray = (array) => {
        const result = [];
        try {
          array.map((i) => {
            if (i.isGroup && i.list && i.list.length > 0) {
              i.list.map((m) => {
                result.push([i.uuid, m.uuid]);
              });
            } else {
              result.push([i.uuid]);
            }
          });
        } catch (e) {
          console.log(e, "数据格式有误");
        }
        return result;
      };
      if (this.activeElementGroupUUID) {
        return getArray(this.activeElementGroup.events[index].elementUUIDs);
      } else if (this.activeElementUUID) {
        return getArray(this.activeElement.events[index].elementUUIDs);
      } else {
        return getArray(this.activePage.events[index].elementUUIDs);
      }
    },
    elementUUIDsMouseEnterHandler(e, data) {
      if (!data.isGroup) {
        const currentElem = this.activePage.elements.find(
          (i) => i.uuid == data.uuid
        );
        let img = "";
        if (currentElem.elName == "qk-image") {
          img = currentElem.propsValue.imageSrc;
        }
        const node = document.getElementById(
          `elementUUIDs-preview-${data.uuid}`
        );
        if (!node) {
          let currentNode = e.target;
          while (currentNode !== null) {
            if (currentNode.classList.contains("el-cascader__dropdown")) {
              break;
            }
            currentNode = currentNode.parentNode;
          }
          const elem = document.createElement("img");
          elem.id = `elementUUIDs-preview-${data.uuid}`;
          elem.src = img;
          elem.style.width = "100px";
          elem.style.height = "auto";
          elem.style.position = "fixed";
          elem.style.left = `${currentNode.offsetLeft - 120}px`;
          elem.style.top = `${currentNode.offsetTop + 20}px`;
          elem.style.zIndex = 9999;
          document.body.append(elem);
        }
      }
    },
    elementUUIDsMouseLeaveHandler(e, data) {
      if (!data.isGroup) {
        const node = document.getElementById(
          `elementUUIDs-preview-${data.uuid}`
        );
        if (node) {
          node.parentNode.removeChild(node);
        } else {
          console.log(e, data.uuid, "elementUUIDsMouseLeaveHandler");
        }
      }
    },
    handleInputMiniProgramForm(form) {
      console.log(form);
    },
  },
};
</script>

<style lang="scss" scoped>
.components-attr-edit {
  height: 100%;
}

.components-attr-animate-edit {
  position: relative;
}

.attr-title {
  font-weight: bold;
}

.attr-item-edit-wrapper {
  padding-left: 4px;
  display: flex;
  width: 100%;
  text-align: center;
  padding-bottom: 10px;
  ::v-deep .attr-item-title {
    text-align: left;
    width: 80px;
    font-size: 12px;
    line-height: 28px;
    color: #fff;
  }
  .attr-item-edit-input {
    text-align: left;
    flex: 1;
    &.col-2 {
      width: 90px;
      margin-left: 10px;
    }
    &.col-1 {
      width: 250px;
    }
    &.col-3 {
      width: 60px;
      margin-left: 10px;
    }
    &.col-4 {
      width: 50px;
      margin-left: 10px;
    }
  }
  .attr-item-edit-input-des {
    text-align: center;
    line-height: 1;
    margin-top: 2px;
    font-size: 12px;
    color: $gray;
  }
}
::v-deep .el-collapse-item__header {
  background: unset;
  color: #fff;
}
::v-deep .el-animate-title-btn {
  color: #fff !important;
}
::v-deep .el-collapse-item__wrap {
  background: unset;
  color: #fff;
}
.el-animate-list-wrapper {
  .el-animate-title-name {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    font-weight: bold;
    width: 55px;
  }
  .el-animate-title-type-wrapper {
    display: inline-flex;
    align-items: center;
    width: 190px;
    margin: 0 20px 0 10px;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .el-animate-title-type {
    display: inline-block;
    vertical-align: middle;
    max-width: 190px;
    height: 24px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: #fafafa;
    border-radius: 60px;
    border: none;
    cursor: pointer;
    line-height: 14px;
  }
  .el-animate-title-btn {
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #666;
    width: 24px;
    height: 24px;
    cursor: pointer;
    border-radius: 4px;
    background: rgba(37, 165, 137, 0.08);
    margin-left: 6px;
    &:hover {
      color: white;
      background: $primary;
    }
  }
}
</style>
